import { render, staticRenderFns } from "./TemplateEditDialog.vue?vue&type=template&id=d4513420&scoped=true&lang=pug"
import script from "./TemplateEditDialog.vue?vue&type=script&lang=js"
export * from "./TemplateEditDialog.vue?vue&type=script&lang=js"
import style0 from "./TemplateEditDialog.vue?vue&type=style&index=0&id=d4513420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4513420",
  null
  
)

export default component.exports